import { render, staticRenderFns } from "./RecordStatus.vue?vue&type=template&id=0c3b5aee&scoped=true&"
import script from "./RecordStatus.vue?vue&type=script&lang=js&"
export * from "./RecordStatus.vue?vue&type=script&lang=js&"
import style0 from "./RecordStatus.vue?vue&type=style&index=0&id=0c3b5aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3b5aee",
  null
  
)

export default component.exports